import styled, { css, keyframes } from 'styled-components';

export const violentShake = keyframes`
  0% { transform: translate(0, 0); }
  10% { transform: translate(-20px, 15px); }
  20% { transform: translate(25px, -10px); }
  30% { transform: translate(-15px, 5px); }
  40% { transform: translate(10px, 10px); }
  50% { transform: translate(-10px, -15px); }
  60% { transform: translate(15px, 5px); }
  70% { transform: translate(-5px, 10px); }
  80% { transform: translate(10px, -10px); }
  90% { transform: translate(-15px, 15px); }
  100% { transform: translate(0, 0); }
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  margin: 0px auto;
  position: relative;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
  overflow-x: hidden;
  align-items: center;
  justify-content: center;
  gap: var(--p-spacing-04);
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: var(--p-spacing-04);
  @media only screen and (max-width: 820px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const MainContent = styled.div<{ shouldShake: Boolean }>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 0.5rem;
  animation: ${(props) => (props.shouldShake ? violentShake : 'none')} 0.5s
    linear infinite;
`;

export const Illustration = styled.img.attrs(() => ({
  src: '/404/images/accident.svg',
}))`
  width: 100%;
  position: absolute;
  right: 50%;
  top: 50%;
  transform: translate(50%, -50%);
`;

export const IllustrationContainer = styled.div<{ shouldShake: Boolean }>`
  display: flex;
  justify-content: center;
  position: relative;
  width: 500px;
  height: 500px;
  max-width: 70vw;
  animation: ${(props) => (props.shouldShake ? violentShake : 'none')} 0.5s
    linear infinite;
`;

export const Fire = styled.img.attrs(() => ({
  src: '/404/images/fire.webp',
}))`
  width: 80%;
`;

export const SpaceInvadersContainer = styled.div<{ open: boolean }>`
  z-index: 10;
  position: ${({ open }) => (open ? 'fixed' : 'relative')};
  display: inline-block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  ${({ open }) =>
    !open &&
    css`
      width: 300px;
      height: 300px;
    `}
  canvas {
    width: 100%;
    height: 100%;
  }
`;

export const ClickToPlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 40px;
`;
